export const GET_WO_PROCESS_LOG_REPORT_REQUEST =
  "GET_WO_PROCESS_LOG_REPORT_REQUEST";
export const GET_WO_PROCESS_LOG_REPORT_SUCCESS =
  "GET_WO_PROCESS_LOG_REPORT_SUCCESS";
export const GET_WO_PROCESS_LOG_REPORT_FAILURE =
  "GET_WO_PROCESS_LOG_REPORT_FAILURE";
